import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase/config";

const createCheckoutSessionFn = httpsCallable(functions, "createCheckoutSession");

/**
 * Crea una Stripe Checkout Session (server-side) e reindirizza a Stripe.
 * @param {string} priceId - Price ID Stripe (da STRIPE_PRICES).
 */
export async function startCheckout(priceId) {
  const res = await createCheckoutSessionFn({ priceId });
  const url = res?.data?.url;
  if (!url) throw new Error("URL di pagamento non ricevuto.");
  window.location.href = url;
}
